import { render, staticRenderFns } from "./ShoppingListTypeahead.vue?vue&type=template&id=47a55a98&scoped=true&"
import script from "./ShoppingListTypeahead.vue?vue&type=script&lang=js&"
export * from "./ShoppingListTypeahead.vue?vue&type=script&lang=js&"
import style0 from "./ShoppingListTypeahead.vue?vue&type=style&index=0&id=47a55a98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../nonspa/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a55a98",
  null
  
)

component.options.__file = "ShoppingListTypeahead.vue"
export default component.exports